export const DIFFICULTY = [
  {
    value: 'Muy baja',
    label: 'Muy baja'
  },
  {
    value: 'Baja',
    label: 'Baja'
  },
  {
    value: 'Medio',
    label: 'Medio'
  },
  {
    value: 'Alta',
    label: 'Alta'
  },
  {
    value: 'Muy alta',
    label: 'Muy alta'
  }
];

export const EDUCATIVE_LEVEL = [
  { value: 'Primera infancia', label: 'Primera infancia' },
  {
    value: 'Educación preescolar, básica y media',
    label: 'Educación preescolar, básica y media'
  },
  { value: 'Educación superior', label: 'Educación superior' },
  {
    value: 'Educación para el trabajo y el desarrollo humano',
    label: 'Educación para el trabajo y el desarrollo humano'
  }
];

export const SUBJECTS = [
  'Ciencias económicas y políticas',
  'Educación artística',
  'Educación religiosa',
  'Tecnología e informática',
  'Ciencias naturales y educación ambiental',
  'Matemáticas',
  'Filosofía'
];

export const ALL_SUBJECTS = [
  'Ciencias económicas y políticas',
  'Ciencias sociales, historia, geografía, constitución política y democracia',
  'Ciencias naturales y educación ambiental',
  'Educación artística',
  'Educación ética y en valores humanos',
  'Educación física, recreación y deportes',
  'Educación religiosa',
  'Tecnología e informática',
  'Humanidades, lengua castellana e idiomas extranjeros',
  'Matemáticas',
  'Filosofía'
];

export const FORMATS_MAP = {
  textual: 'Textual',
  software: 'Software',
  interactive: 'Interactivo',
  graphic: 'Gráfico',
  sonorous: 'Sonoro',
  audiovisual: 'Audiovisual',
  multimedia: 'Multimedia'
};
export const FORMATS = [
  { value: 'Textual', label: 'Textual' },
  { value: 'Gráfico', label: 'Gráfico' },
  { value: 'Sonoro', label: 'Sonoro' },
  { value: 'Audiovisual', label: 'Audiovisual' },
  { value: 'Multimedia', label: 'Multimedia' },
  { value: 'Interactivo', label: 'Interactivo' },
  { value: 'Software', label: 'Software' }
];

export const RESOURCE_TYPE = [
  { value: 'Exposición de contenidos', label: 'Exposición de contenidos' },
  { value: 'Tutorial', label: 'Tutorial' },
  { value: 'Taller', label: 'Taller' },
  { value: 'Actividad interactiva', label: 'Actividad interactiva' },
  { value: 'Evaluación', label: 'Evaluación' }
];

export const OBJECT_TYPE = [
  { value: false, label: 'Recurso', is_default: true },
  { value: true, label: 'Agrupacion' }
];

const COLLECTION = 'Agregación';
const CHRONOLOGY = 'Cronología';
const DISTILLATION = 'Destilación';

export const GROUP_TYPES = [
  { value: COLLECTION, label: 'Colección' },
  { value: CHRONOLOGY, label: 'Línea de tiempo' },
  { value: DISTILLATION, label: 'Ranking' }
];
